<template>
    <b-overlay :show="loading" rounded="sm">

        <div class="h5">
            Áudio
            <span v-b-tooltip.hover title="Aqui você pode comentar por áudio sobre o texto do aluno">
                <i class="fas fa-xs fa-info-circle"></i>
            </span>
        </div>

        <b-card v-if="essay" class="mb-3">

            <div class="alert alert-danger" v-if="record_erro">
                Não conseguimos autorização para acessar o microfone de seu computador :(
            </div>

            <div class="mb-3" v-show="!recording">
                <audio ref="audio" class="audio"></audio>
            </div>

            <div class="mb-3 text-danger" v-if="recording">
                &#128541;
                <span class="ml-1"> Já estamos gravando sua voz ...</span><br>
                Quando terminar aperte no botão abaixo para parar :)
            </div>

            <div v-if="canEdit">

                <button type="button" class="btn btn-danger btn-sm" @click="startRecording" v-if="!record && !recording">
                    <i class="fas fa-microphone mr-1"></i>
                    Iniciar Gravação
                </button>

                <button type="button" class="btn btn-outline-danger btn-sm" @click="stopRecording" v-if="recording">
                    <i class="fas fa-stop mr-1"></i>
                    Parar
                </button>

                <button type="button" class="btn btn-primary btn-sm" @click="saveRecording" v-if="record">
                    <i class="fas fa-save mr-1"></i>
                    Salvar Gravação
                </button>

                <button type="button" class="btn btn-outline-danger btn-sm" @click="startRecording" v-if="record && !recording">
                    <i class="fas fa-undo-alt mr-1"></i>
                    Gravar Novamente
                </button>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import * as RecordRTC from 'recordrtc';

export default {
    props: ['essay'],
    data() {
        return {
            loading: false,
            canEdit: true,
            record: false,
            recording: false,
            record_erro: false,
            audio: null,
            recordRTC: null,
            stream: null,
            time: 0
        }
    },
    mounted() {

        this.audio = this.$refs.audio;
        this.audio.controls = true;

    },
    created() {

        if (this.essay.status === 'OKAY' || this.essay.status === 'WAIT' || this.essay.status === 'BLOCK'){
            this.canEdit = false;
        }

        // Load
        this.load()

    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/essays/' + this.essay.id)
                .then((result) => {
                    const response = result.data.data;

                    if (response.essay.audio_preview) {
                        this.audio.src = response.essay.audio_preview
                    }

                    this.record = false;
                    this.recording = false;

                })
                .finally(() => this.loading = false)
        },

        processVideo(audioVideoWebMURL) {

            this.audio.src = audioVideoWebMURL;
            this.toggleControls();

            this.record = true;

        },

        startRecording() {

            this.record = false;
            this.recording = false;

            const mediaConstraints = {
                audio: true
            };

            navigator.mediaDevices
                .getUserMedia(mediaConstraints)
                .then(
                    this.successCallback.bind(this),
                    this.errorCallback.bind(this)
                );

        },

        successCallback(stream) {

            const options = {
                type: 'audio',
            };

            this.stream = stream;
            this.recordRTC = RecordRTC(stream, options);
            this.recordRTC.startRecording();

            const binaryData = [];
            binaryData.push(stream);

            this.audio.src = window.URL.createObjectURL(new Blob(binaryData, {type: 'application/zip'}));

            this.toggleControls();

            this.recording = true;
            this.record_erro = false;

        },

        errorCallback(err) {
            this.record_erro = true;
        },

        stopRecording() {

            const recordRTC = this.recordRTC;
            recordRTC.stopRecording(this.processVideo.bind(this));
            const stream = this.stream;
            stream.getAudioTracks().forEach(track => track.stop());
            this.record = true;
            this.recording = false;

        },

        saveRecording() {

            this.loading = true;

            const recordedBlob = this.recordRTC.getDataURL((dataURL) => {

                const data = {
                    audio: dataURL
                };

                this.loading = true;

                axios.put('/teacher/essays/' + this.essay.id + '/audio', data)
                    .then((result) => {
                        const response = result.data.data;

                        // Save Message
                        this.$toast.success('O áudio foi salvo :)', {
                            duration: 1500
                        })

                        // Load
                        this.load()

                    })

                    .finally(() => this.loading = false)

            });

        },

    }
}
</script>

<style scoped>

    .audio {
        width: 100%;
    }

</style>
